module.exports = __webpack_public_path__ + "img/campolivre-galeria-foto02.22393f1c.jpg";